import { type FC, Fragment } from "react";

import { BULK_IMPORT_TYPES, IMPORT_TYPE_ICONS } from "./constants";

import { BulkImportType } from "components/server-types";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { Menu, MenuDivider, MenuItem } from "mds/components/Menu";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { ChevronDownIcon } from "mds/icons";

interface BulkImportMenuProps {
  disabled?: boolean;
  onSelectImportType: (importType: BulkImportType) => void;
}

export const BulkImportMenu: FC<BulkImportMenuProps> = ({ disabled, onSelectImportType }) => {
  const menuButton = (
    <SquareButton
      aria-label={t("home.settings.bulk_import_modal.title")}
      className="flex-1 md:flex-none"
      disabled={disabled}
      eventName="Org Users - Bulk enrollment"
      kind="tertiary"
      size="xs"
    >
      <IconText iconEnd={<ChevronDownIcon />} text={t("home.settings.bulk_import_modal.title")} />
    </SquareButton>
  );

  return (
    <Menu menuButton={menuButton}>
      {BULK_IMPORT_TYPES.map((importType) => {
        const IconComponent = IMPORT_TYPE_ICONS[importType];

        return (
          <Fragment key={importType}>
            {importType === "sections" && <MenuDivider />}

            <MenuItem
              eventName="Org Users - Bulk enrollment type selected"
              onClick={() => onSelectImportType(importType)}
            >
              <IconText
                iconStart={<IconComponent />}
                text={t(`home.settings.bulk_import_modal.types.${importType}`)}
              />
            </MenuItem>
          </Fragment>
        );
      })}
    </Menu>
  );
};
